import { render, staticRenderFns } from "./QuoteBuilderOtherLabourComponent.vue?vue&type=template&id=12690d5a&scoped=true"
import script from "./QuoteBuilderOtherLabourComponent.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderOtherLabourComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderOtherLabourComponent.vue?vue&type=style&index=0&id=12690d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12690d5a",
  null
  
)

export default component.exports